var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4122 10.4777C12.3985 11.5574 13.3744 12.1598 14.1095 12.518C14.8647 12.8855 15.1184 13.1212 15.1154 13.4499C15.1098 13.9529 14.513 14.1749 13.9545 14.1835C12.9802 14.1986 12.4136 13.9204 11.9633 13.7101L11.6122 15.3525C12.0641 15.5607 12.9008 15.7423 13.7685 15.7502C15.8052 15.7502 17.1377 14.7449 17.1449 13.1861C17.1529 11.2078 14.4085 11.0983 14.4273 10.214C14.4338 9.9459 14.6896 9.65978 15.2502 9.58703C15.5277 9.55028 16.2937 9.52215 17.1623 9.92209L17.5031 8.33303C17.0361 8.16296 16.4358 8.00012 15.6884 8.00012C13.7714 8.00012 12.4231 9.01918 12.4122 10.4777ZM20.7786 8.13699C20.4067 8.13699 20.0933 8.35393 19.9534 8.68684L17.044 15.6335H19.0793L19.4842 14.5142H21.9713L22.2062 15.6335H24L22.4347 8.13699H20.7786ZM21.0633 10.1621L21.6506 12.9771H20.0421L21.0633 10.1621ZM9.94462 8.13709L8.34037 15.6334H10.2798L11.8833 8.1369L9.94462 8.13709ZM7.07559 8.13709L5.05697 13.2394L4.24041 8.90096C4.14459 8.41665 3.76622 8.13699 3.34603 8.13699H0.0462187L0 8.35468C0.677437 8.50168 1.44712 8.73878 1.91344 8.99246C2.19881 9.14743 2.28019 9.2829 2.37394 9.65115L3.92053 15.6335H5.97L9.11213 8.13699L7.07559 8.13709Z",
    fill: "url(#paint0_linear_304_293)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_293",
    x1: 1103.38,
    y1: 31.297,
    x2: 1125.81,
    y2: -764.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.5c8c5b0ff96890dbbded3c76f39b5456.svg";
export { ForwardRef as ReactComponent };